<template>
  <div class="auction-item-add">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <q-select
            dark
            square
            outlined
            use-input
            input-debounce="1000"
            :options="items"
            :option-label="opt => Object(opt) === opt && 'itemName' && 'Mid' && 'Sid' in opt ? opt.itemName + ' ' + opt.Mid + '_' + opt.Sid : opt"
            label="Item Name"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.itemName"
            @filter="requestItemList"
            @update:model-value="(e) => autoFillItemDetails(e)"
            @blur="v$.fields.itemName.$touch()"
            :error="v$.fields.itemName.$error"
            error-message="Item Name is required"
          >
            <template v-if="fields.itemName" v-slot:append>
              <q-icon name="cancel" @click.stop.prevent="fields.itemName = null" class="cursor-pointer" />
            </template>
          </q-select>
          <q-input
            square
            outlined
            label="Item Main"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.itemMain"
            @update:model-value="(e) => fields.itemMain = e"
            @blur="v$.fields.itemMain.$touch()"
            :error="v$.fields.itemMain.$error"
            error-message="Item Main is required"
          />
          <q-input
            square
            outlined
            label="Item Sub"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.itemSub"
            @update:model-value="(e) => fields.itemSub = e"
            @blur="v$.fields.itemSub.$touch()"
            :error="v$.fields.itemSub.$error"
            error-message="Item Sub is required"
          />
          <q-input
            square
            outlined
            label="Item Desc (optional)"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.itemDesc"
            @update:model-value="(e) => fields.itemDesc = e"
          />
          <q-select
            square
            outlined
            dark
            v-model="fields.currency"
            label="Item Bid Currency (GOLD/EP)"
            :options="sections"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :error="v$.fields.currency.$error"
            error-message="Item Section is required"
          />
          <q-input
            square
            outlined
            label="Item Start Bid"
            color="white"
            type="Number"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.startBid"
            @update:model-value="(e) => fields.startBid = e"
            @blur="v$.fields.startBid.$touch()"
            :error="v$.fields.startBid.$error"
            error-message="Item Price is required"
          />
          <q-input
            square
            outlined
            label="Item Buy Out Price"
            color="white"
            type="Number"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.buyOut"
            @update:model-value="(e) => fields.buyOut = e"
            @blur="v$.fields.buyOut.$touch()"
            :error="v$.fields.buyOut.$error"
            error-message="Item Buy Out Price is required"
          />
          <div class="q-gutter-md row items-start">
            <div class="title-bid-date">Date & Time Bid End</div>
            <q-date
              v-model="fields.bidEnd"
              @blur="v$.fields.bidEnd.$touch()"
              mask="YYYY-MM-DD HH:mm"
              color="purple"
              :error="v$.fields.bidEnd.$error"
              error-message="Bid End Date/Time is required"
            />
            <q-time
              v-model="fields.bidEnd"
              mask="YYYY-MM-DD HH:mm"
              color="purple" 
            />
          </div>
          <q-file
            square
            outlined
            v-model="image"
            label="Pick Image"
            @update:model-value="handleUpload()"
          />
          <div>
            <q-img
              :src="imageUrl"
              v-if="image"
              spinner-color="white"
              style="height: 140px; max-width: 150px"
            />
          </div>
        <q-btn class="auction-item-add-btn" label="Submit" @click="submit"/>
      </q-card-section>
    </q-card>
  </div>
</template>
  <script>
  import { mapActions } from 'vuex';
  import { required } from "vuelidate/lib/validators";
  import { useVuelidate } from '@vuelidate/core'
  
  export default {
    name: 'AuctionItemAdd',
    props: {
      module: {
        require: true,
        type: Object
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        fields: {
          itemMain: {
            required
          },
          itemSub: {
            required
          },
          itemName: {
            required
          },
          currency: {
            required
          },
          startBid: {
            required
          },
          buyOut: {
            required
          },
          bidEnd: {
            required
          }
        }
      }
    },
    data () {
      return {
        fields: {
          itemMain: null,
          itemSub: null,
          itemName: null,
          itemDesc: null,
          currency: null,
          startBid: null,
          buyout: null,
          image: null,
          bidEnd: null
        },
        sections: ['Gold', 'EP'],
        imageUrl: {},
        image: null,
        items: []
      }
    },
    methods: {
      ...mapActions({
        addAuctionItem : 'auction/addAuctionItem',
        requestItemFetch: 'itemShop/requestItemFetch'
      }),
      requestItemList (e, update) {
        if (e) {
          update(async () => {
            await this.requestItemFetch({ itemName: e })
            .then(response => {
              this.items = response.data
            })
            .catch(error => {
              console.log(error.reponse)
            })
          })
          
        }
      },
      autoFillItemDetails (e) {
        if (e) {
          this.fields.itemName = e.itemName
          this.fields.itemMain = e.Mid
          this.fields.itemSub = e.Sid
        }
      },
      async handleUpload () {
        if (this.image) {
          this.imageUrl = URL.createObjectURL(this.image);
        }

        await this.createBase64Image(this.image)
      },
      async submit () {
        this.v$.fields.$touch();

        if (this.v$.fields.$invalid) {
          return
        }

        await this.recaptchaLoad('addauctionitem')

        this.$q.loading.show();
        
        await this.addAuctionItem(this.fields)
          .then(async (response) => {
            await this.recaptchaLoad('addauctionitem')

            this.resetFields()

            this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })
  
            this.$q.loading.hide()
          })
          .catch((error) => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
          })
      },
      createBase64Image: function(FileObject) {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.fields.image = event.target.result;
        }

        reader.readAsDataURL(FileObject);
      },
      resetFields() {
        this.v$.fields.$reset()

        this.fields = {
          itemMain: null,
          itemSub: null,
          itemName: null,
          currency: null,
          itemPrice: null,
          itemStock: null,
          image: null,
          bidEnd: null,
          itemDesc: null
        }
        this.image = null
        this.imageUrl = null
      }
    }
  }
</script>
<style lang="scss">
.auction-item-add {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .title-bid-date {
      font-size: 16px;
      font-weight: 700;
      color: white;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .auction-item-add-btn {
      background-color: #FFC108;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>